import Skeleton from '../feedback/Skeleton';

// Desenha uma listagem, a tela mais comum do backoffice: barra de ações, tabela e paginação.
const ROW_NUMBERS = [0, 1, 2, 3, 4, 5, 6, 7];
const COLUMN_NUMBERS = [0, 1, 2, 3];
// Larguras alternadas entre linhas, para o esqueleto não parecer uma grade. Em porcentagem,
// para a tabela caber no celular sem rolagem lateral.
const CELL_WIDTHS = ['75%', '45%', '60%', '35%'];
const HEADER_WIDTH = '60%';
const CONTROL_HEIGHT = 42;

/** Ocupa a área de conteúdo enquanto o código da página carrega; o menu e o cabeçalho continuam na tela. */
const PageSkeleton = () => (
  <section aria-busy="true" aria-label="Carregando página" className="app-container container-xxl">
    <output className="visually-hidden">Carregando página...</output>
    <div aria-hidden="true" className="card card-flush shadow-none border">
      <div className="card-body">
        <div className="d-flex justify-content-between flex-wrap gap-3">
          <Skeleton className="mw-100" height={CONTROL_HEIGHT} width={300} />
          <div className="d-flex gap-3">
            <Skeleton height={CONTROL_HEIGHT} width={100} />
            <Skeleton height={CONTROL_HEIGHT} width={120} />
          </div>
        </div>
        <table className="table align-middle fs-6 ek-table ek-table--list gy-3 mt-5">
          <thead>
            <tr className="ek-table__hrow">
              {COLUMN_NUMBERS.map((columnNumber) => (
                <th key={columnNumber}>
                  <Skeleton height={12} width={HEADER_WIDTH} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROW_NUMBERS.map((rowNumber) => (
              <tr key={rowNumber}>
                {COLUMN_NUMBERS.map((columnNumber) => (
                  <td key={columnNumber}>
                    <Skeleton width={CELL_WIDTHS[(rowNumber + columnNumber) % CELL_WIDTHS.length]} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-between flex-wrap gap-3 mt-5">
          <Skeleton height={32} width={180} />
          <Skeleton height={32} width={220} />
        </div>
      </div>
    </div>
  </section>
);

export default PageSkeleton;
